import { render } from "./ResearchCardComponent.vue?vue&type=template&id=59058a48&scoped=true"
import script from "./ResearchCardComponent.vue?vue&type=script&lang=js"
export * from "./ResearchCardComponent.vue?vue&type=script&lang=js"

import "./ResearchCardComponent.vue?vue&type=style&index=0&id=59058a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59058a48"]])

export default __exports__